import { createApp, reactive } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles/brand.css';

// Global message modal state
const msgState = reactive({
  visible: false, type: 'info', title: '', text: '', okLabel: 'Aceptar',
  inputMode: false, inputValue: '', inputPlaceholder: '', _resolve: null,
});

const $msg = {
  _state: msgState,
  show(opts = {}) {
    Object.assign(msgState, {
      type: opts.type || 'info', title: opts.title || '', text: opts.text || '',
      okLabel: opts.okLabel || 'Aceptar', inputMode: !!opts.input,
      inputPlaceholder: opts.inputPlaceholder || '', inputValue: '', visible: true,
    });
    return new Promise(r => { msgState._resolve = r; });
  },
  info(text, title)    { return this.show({ type: 'info', text, title }); },
  success(text, title) { return this.show({ type: 'success', text, title }); },
  error(text, title)   { return this.show({ type: 'error', text, title: title || 'Error' }); },
  confirm(text, title) { return this.show({ type: 'confirm', text, title: title || 'Confirmar', okLabel: 'Sí, continuar' }); },
  prompt(text, opts = {}) { return this.show({ type: 'info', text, input: true, ...opts }); },
};

const app = createApp(App);
app.config.globalProperties.$msg = $msg;
app.provide('$msg', $msg);
app.provide('msgState', msgState);
app.use(router).mount('#app');
